import React, { useState, useEffect } from 'react';
import { Row, Col, Label, Input, FormGroup, Card, CardBody, CardHeader, Collapse } from 'reactstrap';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import Select, { components } from 'react-select';

const Option = (props) => {
    return (
        <div>
            <components.Option {...props}>
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                />{" "}
                <label>{props.label}</label>
            </components.Option>
        </div>
    );
};

const FreshWaterIrrigationItemSpecView = ({ handleMultiSelectChange,itemPopupItemField, itemPopupItemSepcQ, handleItemSepcValueChange, pivotTypeList, purposeOfWatertakeList, systemList, typeList, sourceOfWaterList }) => {


    const [isOpen, setIsOpen] = useState(false);
    const [isIconUp, setIsIconUp] = useState(false);
    const [tooltipOpen, setTooltipOpen] = useState(false);

    const itemTypeFieldList = itemPopupItemField.itemFieldTypes;
    const itemFieldCount = itemTypeFieldList.length;

    const toggleTooltip = () => {
        setTooltipOpen(!tooltipOpen)
    };

    const toggle = () => {
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
    };
    useEffect(() => {
        handleHideAllDiv(itemTypeFieldList);
    }, [])

    const handleHideAllDiv = (itemTypeFieldList) => {
        document.querySelectorAll(".item-field").forEach(element => {
            element.style.display = 'none';
        })

        itemTypeFieldList.map(itemTypeField => {
            let className = "." + itemTypeField.className;
            document.querySelectorAll(className).forEach(element => {
                element.style.display = 'block';
            })
        })
    }

    if (itemFieldCount > 0) {
        return (
            <>
                <Card>
                    <CardHeader className ="card-header-click" onClick={toggle}>
                        <Row>
                            <Col sm="11">
                                <h6>Additional Information</h6>
                            </Col>
                            <Col sm="1" className="toggleoutline_lt">{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <Collapse isOpen={isOpen}>
                            <Row >
                                <Col sm="6">
                                    <FormGroup className='item-field type'>
                                        <Label>Type</Label>
                                        <Input type="select" onChange={handleItemSepcValueChange} name="PivotType" id="PivotType" value={itemPopupItemSepcQ.PivotType} >
                                            {pivotTypeList != undefined && pivotTypeList.map(Option =>
                                                <option value={Option.id}>{Option.name}</option>
                                            )}
                                        </Input>
                                    </FormGroup>
                                </Col>
                            </Row>
                            {/*Water Take*/}
                            <Row >
                                <Col sm="6">
                                    <FormGroup className='item-field purpose-of-water-take'>
                                        <Label>Purpose of water take</Label> {' '}
                                        {purposeOfWatertakeList != undefined && purposeOfWatertakeList != null &&
                                            <Input type="select" onChange={handleItemSepcValueChange} name="PurposeOfWatertake" id="PurposeOfWatertake" value={itemPopupItemSepcQ.PurposeOfWatertake}>
                                                <option value={0} >Select type</option>
                                                {purposeOfWatertakeList.map(Option =>
                                                    <option value={Option.id}>{Option.value}</option>
                                                )}
                                            </Input>
                                        }
                                    </FormGroup>
                                </Col>
                            </Row>
                            {/*Irrigation Area*/}
                            <Row >
                                <Col sm="6">
                                    <FormGroup className='item-field system'>
                                        <Label>System</Label> {' '}
                                        {systemList != undefined && systemList != null &&
                                            <Input type="select" onChange={handleItemSepcValueChange} name="System" id="System" value={itemPopupItemSepcQ.System}>
                                                <option value={0} >Select system</option>
                                                {systemList.map(Option =>
                                                    <option value={Option.id}>{Option.value}</option>
                                                )}
                                            </Input>
                                        }
                                    </FormGroup>
                                </Col>
                                <Col sm="6">
                                    <FormGroup className='item-field irrigation-area-type'>
                                        <Label>Type</Label> {' '}
                                        {typeList != undefined && typeList != null &&
                                            <Input type="select" onChange={handleItemSepcValueChange} name="Type" id="Type" value={itemPopupItemSepcQ.Type}>
                                                <option value={0} >Select type</option>
                                                {typeList.map(Option =>
                                                    <option value={Option.id}>{Option.value}</option>
                                                )}
                                            </Input>
                                        }
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row >
                                <Col sm="6">
                                    <FormGroup className='item-field technical-capacity'>
                                        <Label>Technical capacity</Label>
                                        <Input type="textbox" name="TechnicalCapacity" id="TechnicalCapacity" value={itemPopupItemSepcQ.TechnicalCapacity} onChange={handleItemSepcValueChange} />
                                    </FormGroup>
                                </Col>
                                <Col sm="6">
                                    <FormGroup className='item-field system-capacity'>
                                        <Label>System Design Capacity (include detail e.g. l/s, m3/hr, mm/day etc)</Label>
                                        <Input type="textbox" name="SystemCapacity" id="SystemCapacity" value={itemPopupItemSepcQ.SystemCapacity} onChange={handleItemSepcValueChange} />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row >
                                <Col sm="6">
                                    <FormGroup className='item-field return-times'>
                                        <Label>Return times</Label>
                                        <Input type="textbox" name="ReturnTimes" id="ReturnTimes" value={itemPopupItemSepcQ.ReturnTimes} onChange={handleItemSepcValueChange} />
                                    </FormGroup>
                                </Col>
                                <Col sm="6">
                                    <FormGroup className='item-field max-applied-depth'>
                                        <Label>Max applied depth</Label>
                                        <Input type="textbox" name="MaximumAppliedDepth" id="MaximumAppliedDepth" value={itemPopupItemSepcQ.MaximumAppliedDepth} onChange={handleItemSepcValueChange} />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row >
                                <Col sm="6">
                                    <FormGroup className='item-field rate-of-application'>
                                        <Label>Rate of application?</Label>
                                        <Input type="textbox" name="RateOfApplication" id="RateOfApplication" value={itemPopupItemSepcQ.RateOfApplication} onChange={handleItemSepcValueChange} />
                                    </FormGroup>
                                </Col>
                                <Col sm="6">
                                    <FormGroup className='item-field rate-of-application-decided'>
                                        <Label>How is rate of application decided?</Label>
                                        <Input type="textarea" name="RateOfApplicationDecided" id="RateOfApplicationDecided" value={itemPopupItemSepcQ.RateOfApplicationDecided} onChange={handleItemSepcValueChange} />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row >
                                <Col sm="6">
                                    <FormGroup className='item-field has-pond-dam-been-leak-tested'>
                                        <Label>Has pond/dam been leak tested?</Label>
                                        <Input type="select" onChange={handleItemSepcValueChange} name="HasPondDamBeenLeakTested" id="HasPondDamBeenLeakTested" value={itemPopupItemSepcQ.HasPondDamBeenLeakTested}>
                                            <option value={0} >Select</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </Input>
                                    </FormGroup>
                                </Col>
                                {itemPopupItemSepcQ.HasPondDamBeenLeakTested == 'Yes' &&  
                                    <Col sm="6">
                                        <FormGroup className='item-field leak-testing-detail-outcome'>
                                            <Label>Leak testing detail and outcome</Label>
                                            <Input type="textarea" name="LeakTestingDetailOutcome" id="LeakTestingDetailOutcome" value={itemPopupItemSepcQ.LeakTestingDetailOutcome} onChange={handleItemSepcValueChange} />
                                        </FormGroup>
                                    </Col>
                                }
                                <Col sm="6">
                                    <FormGroup className='item-field does-the-storage-comply-with-the-dam-safety-regulations'>
                                        <Label>Does the storage comply with the Dam Safety regulations?</Label>
                                        <Input type="select" onChange={handleItemSepcValueChange} name="DoesTheStorageComplyWithTheDamSafetyRegulations" id="DoesTheStorageComplyWithTheDamSafetyRegulations" value={itemPopupItemSepcQ.DoesTheStorageComplyWithTheDamSafetyRegulations}>
                                            <option value={0} >Select</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </Input>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="6">
                                    <FormGroup className='item-field source-of-water'>
                                        <Label>Source of water</Label>
                                        {sourceOfWaterList != undefined && sourceOfWaterList != null &&
                                            <Select className="dropdown" components={{
                                                Option
                                        }} placeholder="Select Type" closeMenuOnSelect={false} value={itemPopupItemSepcQ.SelectedSourceOfWater}
                                            options={sourceOfWaterList} onChange={handleMultiSelectChange} isMulti isClearable />
                                        }
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Collapse>
                    </CardBody>
                </Card>
                <br />
            </>
        )
    }

}
export default FreshWaterIrrigationItemSpecView